module.exports = __webpack_public_path__ + "Kanit-Regular.b9db1be951b3e8b21966.otf";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/fonts/Kanit-Regular.otf
// module id = ../../../../../src/assets/fonts/Kanit-Regular.otf
// module chunks = styles